<template>
  <div>
    <div v-if="loading">
      <Loading />
    </div>
    <div class="p-6 text-center text-gray-500 border rounded bg-gray-50" v-else-if="areas.meta.total < 1">
      <div>You have no areas.</div>
      <button type="button" class="mt-4 btn btn-secondary btn-sm" v-submitting="submitting" @click="syncAreas">
        Sync Areas
      </button>
    </div>
    <div v-else>
      <div class="h-48 p-1 overflow-x-visible overflow-y-auto border rounded">
        <label class="flex items-center px-1 py-2 border-0 cursor-pointer" v-for="area in areas.data" :key="area.id">
          <toggle 
            :value="isInArray(area.id)" 
            :name="area.id.toString()" 
            @change="toggleArea(area)"
            class="mb-0 mr-3" />
          <span class="mr-2">{{ area.areaname }} </span>
          <small class="text-gray-500">{{ area.areano }}</small>
        </label>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapState } from 'vuex'

  export default {
    name: 'AreaToggle',

    created () {
      this.getAreas()
    },

    props: {
      parent: {
        type: Object
      },

      type: {
        type: String
      }
    },

    computed: {
      options () {
        return this.areas.map(area => area.id)
      },
    },

    data () {
      return {
        loading: true,
        submitting: false,
        areas: {
          meta: {},
          data: []
        }
      }
    },

    methods: {
      isInArray (id) {
        return this.parent.areas.some(area => area.id === id)
      },

      toggleArea (area) {
        this.$emit('toggle', area)
      },

      async getAreas () {
        try {
          this.loading = true
          const { data } = await this.$api.get(`account/${this.$route.params.account}/areas`, {
            params: {
              page: this.$route.query.page || 1,
              limit: 1000
            }
          })
          this.areas = data.areas
          this.loading = false
        } catch (error) {
          console.error(error)
          this.$toasted.error(error.response.data.message)
        }
      },
      
      async syncAreas () {
        try {
          this.submitting = true
          await this.$api.put(`account/${this.$route.params.account}/areas`)
          this.getAreas()
        } catch (error) {
          console.error(error)
          this.$toasted.error(error.response.data.message)
        } finally {
          this.submitting = false
        }
      }
    }
  }
</script>